import React from 'react';
import { Button, IconButton } from 'react-toolbox/lib/button';
import styleDialog from '~/style/dialog.scss';
import styleLocal from './style.scss';

const Dialog = (props, context) =>
  <div className={[styleDialog.background, styleDialog[props.transition]].join(' ')} onClick={() => context.dialogClose(props.dialogId)}>
    <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
      <IconButton className={styleDialog.closeButton} icon="close" onClick={() => context.dialogClose(props.dialogId)} />
      <div className={styleDialog.content}>
        {typeof props.data.content === 'string' && <div>
          <div>{props.data.content}</div>
          <div style={{ paddingTop: '10px', whiteSpace: 'pre-line' }}>{props.data.subContent}</div>
        </div>}
        {typeof props.data.content === 'function' && props.data.content()}
        {typeof props.data.onConfirm === 'function' && <div>
          <Button
            onClick={() => { context.dialogClose(props.dialogId); props.data.onConfirm(); }}
            className={styleLocal.buttonConfirm}
            label="Confirm"
            icon="done"
          />
          <Button
            onClick={() => context.dialogClose(props.dialogId)}
            className={styleLocal.buttonCancel}
            label="Cancel"
            icon="clear"
          />
        </div>}
      </div>
    </div>
  </div>;

Dialog.contextTypes = {
  dialogClose: React.PropTypes.func.isRequired
};

export default Dialog;



// WEBPACK FOOTER //
// ./app/dialogs/Message/index.js